<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperMaterialsEquipmentCatalog',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'MaterialsEquipmentCatalogModule',
    };
  },
};
</script>
